// extracted by mini-css-extract-plugin
export default {"submitButtonWrapper":"style_submitButtonWrapper__mbota","buttonWrapper":"style_buttonWrapper__0f8HB"};